import {
  axiosDeleteRequest,
  axiosGetRequest,
  axiosPostRequest,
  axiosPutRequest,
  getHealthPictureRoute,
  getReferenceRoute,
} from '../../api';
import { CreateTreatmentDto, UpdateTreatmentDto } from './dtos';
import { Treatment, TreatmentSearchResult } from './models';

const getTreatmentRoute = () => `${getHealthPictureRoute()}/treatments`;
const getSearchRoute = () => `${getReferenceRoute()}/treatments`;
const SEARCH_RESULTS_MAX = 20;

export const fetchTreatmentsCall = (healthjourneyId: string) => {
  return axiosGetRequest<Treatment[]>(
    `${getTreatmentRoute()}/${healthjourneyId}`
  );
};

export const searchTreatmentsCall = (searchString: string) => {
  const encodedSearchString = encodeURIComponent(searchString);
  return axiosGetRequest<TreatmentSearchResult[]>(
    `${getSearchRoute()}/${encodedSearchString}/${SEARCH_RESULTS_MAX}`
  );
};

export const insertTreatmentsCall = (newTreatments: CreateTreatmentDto[]) => {
  return axiosPostRequest<CreateTreatmentDto[], Treatment[]>(
    `${getTreatmentRoute()}`,
    newTreatments
  );
};

export const updateTreatmentCall = (treatment: UpdateTreatmentDto) => {
  return axiosPutRequest<UpdateTreatmentDto, Treatment>(
    `${getTreatmentRoute()}`,
    treatment
  );
};

export const deleteTreatmentCall = (treatmentId: string) =>
  axiosDeleteRequest<string, void>(`${getTreatmentRoute()}/${treatmentId}`);
